import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from './Icons';

export const Pagination = ({ currentPage, totalPages, totalItems, itemsPerPage, onPageChange }) => {
  const start = (currentPage - 1) * itemsPerPage + 1;
  const end = Math.min(currentPage * itemsPerPage, totalItems);

  const renderPageButtons = () => {
    const buttons = [];
    const maxVisible = 5;
    
    for (let i = 1; i <= Math.min(maxVisible, totalPages); i++) {
      buttons.push(
        <button
          key={i}
          className={`w-8 h-8 inline-flex items-center justify-center border rounded-md text-sm cursor-pointer 
            transition-all font-sans
            ${currentPage === i 
              ? 'bg-purple-500 text-white border-purple-500' 
              : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50'}`}
          onClick={() => onPageChange(i)}
        >
          {i}
        </button>
      );
    }

    if (totalPages > maxVisible) {
      buttons.push(
        <button key="dots" className="w-8 h-8 inline-flex items-center justify-center border border-slate-200 
          rounded-md text-sm bg-white text-slate-400" disabled>...</button>
      );
      buttons.push(
        <button
          key={totalPages}
          className={`w-8 h-8 inline-flex items-center justify-center border rounded-md text-sm cursor-pointer 
            transition-all font-sans
            ${currentPage === totalPages 
              ? 'bg-purple-500 text-white border-purple-500' 
              : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50'}`}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages}
        </button>
      );
    }

    return buttons;
  };

  return (
    <div className="flex justify-between items-center px-5 py-4 border-t border-slate-200/50">
      <div className="text-sm text-slate-500">Showing {start}-{end} of {totalItems} notifications</div>
      <div className="flex gap-1">
        <button
          className="w-8 h-8 inline-flex items-center justify-center border border-slate-200 rounded-md 
            bg-white cursor-pointer transition-all hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronLeftIcon />
        </button>
        {renderPageButtons()}
        <button
          className="w-8 h-8 inline-flex items-center justify-center border border-slate-200 rounded-md 
            bg-white cursor-pointer transition-all hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  );
};
